import { render, staticRenderFns } from "./noticeSetting.vue?vue&type=template&id=67181135&scoped=true&"
import script from "./noticeSetting.vue?vue&type=script&lang=js&"
export * from "./noticeSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67181135",
  null
  
)

export default component.exports